<script lang="ts">
  export let size: string | number = 15;
  export let customClass: string = '';

  const viewBoxWidth = 15;
  const viewBoxHeight = 15;
</script>

<svg
  width="{size}"
  height="{size}"
  viewBox="0 0 {viewBoxWidth} {viewBoxHeight}"
  class="{customClass}"
  aria-hidden="true"
  role="img"
  xmlns="http://www.w3.org/2000/svg"
>
  <path d="M2.04571 9.68161H5.27462V12.9182H2.04571V9.68161Z" fill="currentColor"></path><path
    d="M6.36095 12.9182V9.69091H9.58528V12.9182H6.36095Z"
    fill="currentColor"
  ></path><path d="M6.36095 5.37631H9.58528V8.60361H6.36095V5.37631Z" fill="currentColor"></path><path
    d="M13.8918 5.39259V8.60361H10.6668V5.39259H13.8918Z"
    fill="currentColor"
  ></path><path d="M13.8918 12.9182H10.6668V9.69091H13.8918V12.9182Z" fill="currentColor"></path><path
    d="M10.6622 1.078H13.8918V4.29831H10.6622V1.078Z"
    fill="currentColor"
  ></path>
</svg>
